import styled from 'styled-components';

export const WpDocumentLinkStyled = styled.a`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  color: ${({ theme }) => theme.colors.blue[500]};
  display: block;
  padding: ${({ theme }) => theme.spacings[500]};
  text-decoration: none;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey[100]};
  }
`;
